import React, { useState, useEffect } from "react";
import {
    Dialog,
    DialogContent,
    Typography,
    Button,
} from "@mui/material";
import ModalCloseButton from "../../components/UI/ModalCloseButton";

function DeleteModal({ open, onClose, onConfirm }) {
    const [isDeleted, setIsDeleted] = useState(false);

    // Reset state when modal closes
    useEffect(() => {
        if (!open) {
            setIsDeleted(false);
        }
    }, [open]);

    const handleConfirm = async () => {
        await onConfirm();
        setIsDeleted(true);
    };

    const handleClose = () => {
        setIsDeleted(false);
        onClose();
    };

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            maxWidth="xs"
            PaperProps={{
                style: {
                    borderRadius: "4px",
                    padding: "20px",
                    width: "320px",
                    textAlign: "center",
                    position: "relative",
                },
            }}
        >
            <ModalCloseButton onClick={handleClose} />

            {isDeleted ? (
                <>
                    <Typography
                        style={{
                            fontFamily: "Poppins",
                            fontSize: "14px",
                            color: "#444444",
                            marginBottom: "20px",
                            marginTop: "12px",
                        }}
                    >
                        The report has been deleted
                    </Typography>
                    <DialogContent style={{ padding: 0 }}>
                        <Button
                            onClick={handleClose}
                            style={{
                                padding: "6px 16px",
                                backgroundColor: "#0F9BB0",
                                color: "white",
                                borderRadius: "4px",
                                textTransform: "none",
                                fontFamily: "Poppins",
                                fontWeight: 500,
                                fontSize: "14px",
                                minWidth: "100px",
                            }}
                        >
                            Close
                        </Button>
                    </DialogContent>
                </>
            ) : (
                <>
                    <Typography
                        style={{
                            fontFamily: "Poppins",
                            fontSize: "14px",
                            color: "#444444",
                            marginBottom: "20px",
                            marginTop: "12px",
                        }}
                    >
                        Are you sure to delete the report?
                    </Typography>
                    <DialogContent style={{ padding: 0 }}>
                        <div
                            style={{
                                display: "flex",
                                gap: "12px",
                                justifyContent: "center",
                            }}
                        >
                            <Button
                                onClick={handleConfirm}
                                style={{
                                    padding: "6px 16px",
                                    backgroundColor: "white",
                                    color: "#0F9BB0",
                                    border: "2px solid #0F9BB0",
                                    borderRadius: "4px",
                                    textTransform: "none",
                                    fontFamily: "Poppins",
                                    fontWeight: 500,
                                    fontSize: "14px",
                                    minWidth: "100px",
                                }}
                            >
                                Yes, delete
                            </Button>
                            <Button
                                onClick={handleClose}
                                style={{
                                    padding: "6px 16px",
                                    backgroundColor: "#0F9BB0",
                                    color: "white",
                                    borderRadius: "4px",
                                    textTransform: "none",
                                    fontFamily: "Poppins",
                                    fontWeight: 500,
                                    fontSize: "14px",
                                    minWidth: "100px",
                                }}
                            >
                                No, keep it
                            </Button>
                        </div>
                    </DialogContent>
                </>
            )}
        </Dialog>
    );
}

export default DeleteModal;
